import { FunctionComponent } from 'react'
import styled from 'styled-components'

import ExtraLargeHeader from './ExtraLargeHeader'

const Container = styled.div``

interface IImageSrcProps {
  imageSrc: string
}
const ImageContainer = styled.div<IImageSrcProps>`
  height: 200px;
  width: 100%;
  background: center / cover url(${props => props.imageSrc});
`

const BottomContainer = styled.div`
  min-height: 100vh;
  display: flex;
  justify-content: center;
`

const ContentContainer = styled.div`
  margin: -100px 10px 0;
  padding: 50px ${props => props.theme.metrics.gutterPhone}px;
  max-width: ${props => props.theme.metrics.footerArticleMaxWidth}px;
  background: ${props => props.theme.colors.white};
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    padding: 100px 150px;
  }
`

const TitleContainer = styled.div`
  margin-bottom: 50px;
  @media (min-width: ${props => props.theme.metrics.tablet}px) {
    margin-bottom: 100px;
  }
`

interface IProps {
  title: string
  imageSrc: string
}

const FooterPageLayout: FunctionComponent<IProps> = ({ children, imageSrc, title }) => (
  <Container>
    <ImageContainer imageSrc={imageSrc} />
    <BottomContainer>
      <ContentContainer>
        <TitleContainer>
          <ExtraLargeHeader
            title={title}
            noMargin
          />
        </TitleContainer>
        {children}
      </ContentContainer>
    </BottomContainer>
  </Container>
)

export default FooterPageLayout
